//@flow
import type { ReducerState$Type } from '../genericFlowTypes'
import type { EditFormData } from '../phobos/flowTypes'

export const transformDataToEditFormData=(data:any,deimos: ReducerState$Type)=>{
    let formData: EditFormData = {}
    
    const deimosResultsetData = data['deimosResultset']
    formData.isInvalidDoc = deimosResultsetData['is_invalid_doc']?deimosResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = deimosResultsetData['is_override_vendor_name']?deimosResultsetData['is_override_vendor_name']:false
    formData.isOverrideTotal = deimosResultsetData['is_override_total']?deimosResultsetData['is_override_total']:false
    
    if (deimosResultsetData['inv_no']){
        formData.invNo = deimosResultsetData['inv_no']
    }
    if (deimosResultsetData['inv_date']){
        formData.invDate = deimosResultsetData['inv_date']
    }
    if (deimosResultsetData['po_no']){
        formData.poNo = deimosResultsetData['po_no']
    }
    if (deimosResultsetData['service_addr']){
        formData.serviceAddr = deimosResultsetData['service_addr']
    }
    if (deimosResultsetData['total']){
        formData.total = parseFloat(deimosResultsetData['total'])
    }
    if (deimosResultsetData['vendor_name']){
        formData.vendorName = deimosResultsetData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/deimos/editFormData.js